import { type ReactNode } from 'react';

interface SeoProps {
  title: string;
  description: string;
  path: string;
  noindex?: boolean;
  children?: ReactNode;
}

export function Seo({ title, description, path, noindex, children }: SeoProps) {
  const canonical = `https://ai-free-resume.org${path === '/' ? '' : path}`;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      {children}
    </>
  );
}

export default Seo;
